import { objectToSnakeCase, objectToCamelCase } from '../utils'

import NotificationAPI from './api'

export default class Notification {
  static api = NotificationAPI.create(Notification)

  constructor({ id = null, recipient = '', message = '', isRead = false } = {}) {
    Object.assign(this, {
      id,
      recipient,
      message,
      isRead,
    })
  }

  copy() {
    return new Notification(this)
  }

  update(data = {}) {
    return Object.assign(this.copy(), data)
  }

  static create(data = {}) {
    return new Notification(data)
  }

  static fromAPI(json = {}) {
    return new Notification(objectToCamelCase(json))
  }

  /* Prep data for the API. Can elect to include */
  static toAPI(notification, fields = []) {
    let data = {}
    if (fields.length > 0) {
      fields.forEach(field => {
        data[field] = notification[field]
      })
    } else {
      data = notification
    }

    return objectToSnakeCase(data)
  }

  static checkIsInstance(obj, name) {
    if (!(obj instanceof Notification)) {
      throw Error(`${name} must be an instance of the Notification class.`)
    }
  }
}
